import { profile, axiosConfig } from 'api';

import { CostCenter, GetAllCostCenterResponse } from 'models/costCenter';
import { Response } from 'models/response';

export const getCostCenters = async (
  companyId: string,
  query?: string,
  pageSize?: number,
  pageNumber?: number,
  onlyActive?: boolean,
  onlyFalse?: boolean,
): Promise<GetAllCostCenterResponse> => {
  try {
    const response = await profile.post<GetAllCostCenterResponse>(
      '/CostCenter/GetAllCostCenter',
      {
        search: query ?? '',
        pageSize: pageSize ?? 100000000,
        pageNumber: pageNumber ?? 1,
        onlyActive: onlyActive ?? true,
        onlyFalse: onlyFalse ?? false,
        companyId,
      } as any,
      axiosConfig,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveCostCenter = async (costCenter): Promise<CostCenter> => {
  try {
    const response = costCenter.id
      ? await profile.put<Response<CostCenter>>(`/costCenter/${costCenter.id}`, {
          ...costCenter,
          budget: costCenter.budget === 'undefined' ? '0' : `${costCenter.budget}` ?? '0',
        })
      : await profile.post<Response<CostCenter>>('/costCenter', {
          ...costCenter,
          budget: costCenter.budget === 'undefined' ? '0' : `${costCenter.budget}` ?? '0',
          isActive: true,
        });
    return response.data.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};
